import { Entry, EntryCollection } from 'contentful';

import { getContentType } from '@/core/constants';
import { TypeVariantImageSet } from '@/core/generated-types/TypeVariantImageSet';

import { getVariantId } from '@/utils/helpers';

import { ShopifyProduct } from '../shopify';

async function updateVariantImage(entry: Entry<any>) {
  const contentType = getContentType(entry);

  if (contentType === 'product' && entry.fields.shopifyProduct) {
    const variantImageSets = entry.fields
      .variantImageSets as TypeVariantImageSet[];

    const shopifyProduct = entry.fields.shopifyProduct as ShopifyProduct;

    for (const variant of shopifyProduct?.variants ?? []) {
      const variantId = getVariantId(variant);

      const variantImageSet = variantImageSets?.find(
        (vis: TypeVariantImageSet) => vis.fields.variantId === variantId,
      );

      const variantThumbnail = variantImageSet?.fields.thumbnail;

      if (variantThumbnail?.fields?.Image?.fields?.file?.url) {
        variant.image.url = `https:${variantThumbnail.fields.Image.fields.file.url}`;
      }
    }
  }
}

async function checkNextLevel(entry: Entry<any>) {
  if (entry.fields) {
    for (const nestedEntry of Object.values(entry.fields as Entry<any>)) {
      await customizeVariantImage(nestedEntry);
    }
  }

  if (Array.isArray(entry)) {
    for (const nestedEntry of entry) {
      await customizeVariantImage(nestedEntry);
    }
  }
}

async function customizeVariantImage(entry: Entry<any> | undefined) {
  if (!entry) return;

  await updateVariantImage(entry);

  await checkNextLevel(entry);
}

export default async function customizeVariantImages<T extends object>(
  entries: EntryCollection<T>,
) {
  const fetchPromises = entries.items.map((entry) =>
    customizeVariantImage(entry),
  );

  await Promise.all(fetchPromises);

  return entries;
}
